// gatsby-ssr.js
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18next from './src/utils/i18n';
import { PageContextProvider } from './src/hooks/pageContext';

export const wrapRootElement = ({ element, props }) => (
    <I18nextProvider {...props} i18n={i18next}>
        {element}
    </I18nextProvider>
);

export const wrapPageElement = ({ element, props }) => (
    <PageContextProvider pageContext={props.pageContext}>
        {element}
    </PageContextProvider>
);
